import React from 'react';

import { useTranslation } from 'react-i18next';

import { TABS_PADDING, TAB_ITEM_WIDTH } from '../../constants/tabbar';
import { GenericVoidFunction } from '../../types/genericTypes';

import './StyledTabBar.scss';

export interface TabBarProps {
  items: string[];
  activeIndex: number;
  action: GenericVoidFunction;
}

const StyledTabBar = ({ items, action, activeIndex }: TabBarProps) => {
  const { t } = useTranslation();

  return (
    <div className="tab-bar" style={{ width: TAB_ITEM_WIDTH * items.length + (items.length + 1) * TABS_PADDING }}>
      {items.map((item, index) => (
        <div
          key={`tab-item-${item}-${index}`}
          className={`tab-item ${activeIndex === index ? 'active' : ''}`}
          onClick={() => action(index)}
        >
          <p className="tab-item-text whitespace-nowrap">{t(item)}</p>
        </div>
      ))}
      <div
        className="indicator"
        style={{ width: TAB_ITEM_WIDTH, left: activeIndex * TAB_ITEM_WIDTH + (activeIndex + 1) * TABS_PADDING }}
      />
    </div>
  );
};

export default StyledTabBar;
